import React from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

function categoriesString(industry) {
  return industry.categories.map(category => {
    return <div key={category._id} style={{marginBottom: '2px', marginTop: '2px'}}>{category._id} {category.name}<br/></div>
  })
}

export default function IndustryRow(props) {
  return (
    <TableRow key={props.industry._id}>
      <TableRowColumn style={{whiteSpace:'normal'}}>{props.industry.name}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>{props.industry.searchTerms}</TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {categoriesString(props.industry)}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width:'90px'}}>
        <FlatButton label="Muokkaa" onTouchTap={() => props.onIndustrySelected(props.rowNumber)}/>
      </TableRowColumn>
    </TableRow>
  );
}



// WEBPACK FOOTER //
// ./src/components/IndustriesPage/IndustryRow.js